import { createReducer, on } from '@ngrx/store';
import { TAppUser } from '../../../entity/types/tappuser';
import { getUser, setUser } from './user.actions';
import { EUserRole } from '../../../../../../regocheckshared/enums/euserrole';

export interface UserState {
    user: TAppUser;
    adminClientId?:string;
    adminClientName?:string;
    error: string;
    isLoading: boolean;
  }
  
  const initialUserState: UserState = {
    user: {
      userId:'',
      token: '',
      clientId:'',
      role:null as unknown as EUserRole
    },
    adminClientId:null as unknown as string,
    adminClientName:null as unknown as string,
    error: '',
    isLoading: false
  };
  
  export const loginReducer = createReducer(initialUserState,
    on(getUser, state => ({ ...state, loading: true })),
    on(setUser, (state, { user }) => ({ ...state, user }))
  );